import { action } from '@storybook/addon-actions';
var Home = {
  template: "\n    <div>\n      <h2>Home</h2>\n      \n      <div style=\"display: flex; gap: 1em\">\n        <router-link to=\"/\">Home</router-link>\n        <router-link to=\"/about\">About</router-link>\n      </div>\n    </div>\n  "
};
var About = {
  template: "\n    <div>\n      <h2>About</h2>\n\n      <div style=\"display: flex; gap: 1em\">\n        <router-link to=\"/\">Home</router-link>\n        <router-link to=\"/about\">About</router-link>\n      </div>\n    </div>\n  "
};
export var defaultRoutes = [{
  path: '/',
  name: 'home',
  component: Home,
  beforeEnter: function beforeEnter(to, from) {
    return action('beforeEnter')({
      to: to.fullPath,
      from: from.fullPath
    });
  }
}, {
  path: '/about',
  name: 'about',
  component: About,
  beforeEnter: function beforeEnter(to, from) {
    return action('beforeEnter')({
      to: to.fullPath,
      from: from.fullPath
    });
  }
}];